/** Web Locks steal (multi-tab Supabase auth, pending-send flush) — not a product bug. */
export function isBenignLockAbortError(reason: unknown): boolean {
  if (!(reason instanceof DOMException) || reason.name !== "AbortError") return false;
  const msg = reason.message ?? "";
  return msg.includes("Lock broken") || msg.includes("steal");
}
